import { render, staticRenderFns } from "./AppPromo.vue?vue&type=template&id=7399198f&"
import script from "./AppPromo.vue?vue&type=script&lang=js&"
export * from "./AppPromo.vue?vue&type=script&lang=js&"
import style0 from "./AppPromo.vue?vue&type=style&index=0&id=7399198f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports